<script>
import { authMethods } from '@state/helpers'
export default {
  page: {
    title: 'Welcome',
    meta: [{ name: 'description', content: 'The Welcome page.' }],
  },
  components: {},
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      model: 0,
      colors: ['indigo', 'warning', 'pink darken-2', 'red lighten-1'],

      slides: [
        {
          title: 'Hello',
          src: require('@assets/images/safehaven/Welcome1.png'),
          desc:
            'Welcome to safe haven, your one-stop health platform. we consolidate health data to help guide your decision-making process while keeping your information provate and safe.',
        },
        {
          title: 'Get the medical help with symptom checker',
          src: require('@assets/images/safehaven/Welcome2.png'),
          desc:
            'Symptom Checker uses machine learning, backed with best-in-class artificial intellinence, to assess your symptomss and point you towards the best medical solution.',
        },
        {
          title: 'Connect with a medical professional',
          src: require('@assets/images/safehaven/Welcome3.png'),
          desc:
            "We'll assess your health needs and find the right physican, counselor or coach.You can schedule an in-person appointment or an online visit via secure chat or telehealth.",
        },
        {
          title: 'Create a plan to help you move forward',
          src: require('@assets/images/safehaven/Welcome4.png'),
          desc:
            'Get effective treatement plans based on your personal data with high-priority goals, measurable objectives and a timeline for treatement progress.',
        },
      ],
    }
  },
  methods: {
    ...authMethods,
  },
}
</script>

<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col align="center">
        <v-carousel
          hide-delimiter-background
          show-arrows-on-hover
          :continuous="false"
          :show-arrows="false"
        >
          <v-carousel-item v-for="(slide, i) in slides" :key="i">
            <v-sheet height="100%">
              <v-row class="fill-height" align="center" justify="center">
                <div :class="$style.textInner">
                  <div :class="$style.carouselContent">
                    <h2
                      >{{ slide.title }}
                      <span v-if="i === 0">{{ user.first_name }}!</span></h2
                    >
                    <img :src="slide.src" width="90%" />
                    <p>{{ slide.desc }}</p>
                    <div v-if="i === slides.length - 1">
                      <router-link
                        :class="$style.btnClss"
                        to="/safehaven/dashboard"
                        >Get Started
                      </router-link>
                    </div>
                  </div>
                </div>
              </v-row>
            </v-sheet>
          </v-carousel-item>
        </v-carousel>
      </v-col>
    </v-row>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';
.textInner {
  max-width: 460px;
  padding: 0 40px;
  margin: 0 auto;
}
.carouselContent {
  max-width: 100%;
  overflow: hidden;
  text-align: center;
}

.carouselContent h2 {
  margin-bottom: 20px;
  font-size: 28px;
  font-weight: 500;
}
.carouselContent p {
  margin-top: 36px;
  font-size: 18px;
  font-weight: 300;
  line-height: normal;
}
.btnClss {
  display: block;
  width: 100%;
  padding: 16px 20px;
  color: #fff !important;
  text-decoration: none;
  background-color: #0476d9;
  border-radius: 30px;
}
</style>
